var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaBaseInput',{attrs:{"autocomplete":_vm.autocomplete,"label":_vm.labelOrDefault,"rules":_vm.rules,"name":_vm.passwordType,"type":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})}
var staticRenderFns = []

export { render, staticRenderFns }